var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('Tjanster')],1),_c('div',{staticClass:"column is-one-third has-text-centere has-text-centered"},[_c('TjansterBubbles'),_c('Img',{attrs:{"src":"hus","alt":"Åsvägens Redovising AB hus i Hässleholm","text":[
          'Åsvägens Redovisning har kontor i södra Hässleholm, i korsvirkeshuset i svängen'
        ]}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }